import { makeStyles, Theme } from "@material-ui/core";
import { centerItemFlex } from "../../../utils/styles";

const customIconStyles = makeStyles(
  (theme: Theme) => ({
    centerAlignedBox: {
      ...centerItemFlex,
    },
  }),
  { index: 1 }
);

export default customIconStyles;
